import { Box, BoxProps } from "@mui/material";
import { useEffect, useState } from "react";

export interface ImageProps extends Omit<BoxProps<"img">, "component" | "src" | "children"> {
    src?: string | File | Blob | null
}

export default function Image({
    src,
    ...props
}: ImageProps) {
    const [objectURL, setObjtectURL] = useState<string>();

    useEffect(() => {
        if (!src) {
            setObjtectURL(undefined);
            return;
        }
        if (typeof src === "string") {
            setObjtectURL(src);
            return;
        }

        const url = URL.createObjectURL(src);
        setObjtectURL(url);
        return () => URL.revokeObjectURL(url);
    }, [src])

    return <Box {...props} component={"img"} src={objectURL} />
}